<template>
  <div class="timer-widget text-center">
    <div class="text-muted small mb-1">{{ label }}</div>
    <div class="timer-widget__display">{{ display }}</div>
    <div class="btn-group btn-group-sm mt-2">
      <button class="btn btn-success" @click="start">Start</button>
      <button class="btn btn-warning" @click="pause">Pause</button>
      <button class="btn btn-secondary" @click="reset">Reset</button>
    </div>
  </div>
</template>

<script>
import serviceLinkMixin from '@/widgets/serviceLinkMixin'

export default {
  mixins: [serviceLinkMixin],
  props: { config: { type: Object, default: () => ({}) } },
  data() {
    return {
      seconds: this.config.duration || 600,
      running: false,
      timer: null,
    }
  },
  computed: {
    label() {
      if (this.usesService) return this.activeService.timerLabel || this.activeService.name
      return this.config.label || 'Timer'
    },
    mode() {
      if (this.usesService) return this.activeService.timerMode || 'countdown'
      return this.config.mode || 'countdown'
    },
    currentSeconds() {
      if (this.usesService) return this.serviceCountdownRemaining
      return this.seconds
    },
    display() {
      const s = Math.abs(this.currentSeconds)
      const m = Math.floor(s / 60)
      const sec = s % 60
      const prefix = this.mode === 'countdown' && this.currentSeconds < 0 ? '-' : ''
      return `${prefix}${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
    },
  },
  watch: {
    'config.duration'(v) {
      if (!this.usesService && !this.running) this.seconds = v || 600
    },
  },
  beforeDestroy() { clearInterval(this.timer) },
  methods: {
    start() {
      if (this.usesService) {
        this.startServiceCountdown()
        return
      }
      if (this.running) return
      this.running = true
      this.timer = setInterval(() => {
        this.seconds += this.mode === 'countdown' ? -1 : 1
      }, 1000)
    },
    pause() {
      if (this.usesService) {
        this.pauseServiceCountdown()
        return
      }
      this.running = false
      clearInterval(this.timer)
    },
    reset() {
      if (this.usesService) {
        this.resetServiceCountdown()
        return
      }
      this.pause()
      this.seconds = this.config.duration || 600
    },
  },
}
</script>

<style scoped>
.timer-widget__display {
  font-size: var(--ws-display-size, 32px);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ws-text);
}
</style>
